// @ts-strict-ignore
import React, { memo } from 'react'

import { PopupBanners } from '@/widgets/Header/ui/popup-banners/popup-banners'
import { PopupBrands } from '@/widgets/Header/ui/popup-brands/popup-brands'
import { PopupList } from '@/widgets/Header/ui/popup-list/popup-list'

import { TBurgerLevel1 } from '@/shared/types/deprecated-types'

import cl from './style.module.scss'

export type NavigationPopupProps = {
	content: TBurgerLevel1
}

/** Popup component for displaying subcategories
 *
 * @param props
 * @param props.items - array of subcategories
 * @param props.title - The title of parent category
 * @param props.imageSrc - Category Image src
 * @param props.sectionLink - The link to parent category
 * */
export const Popup = memo((props: NavigationPopupProps): JSX.Element => {
	const { content } = props

	const COLUMN_ITEMS = content?.SUB_MENU.reduce((acc, item) => {
		if (!acc[item.COLUMN]) {
			acc[item.COLUMN] = []
		}
		acc[item.COLUMN].push(item)
		return acc
	}, []).filter(item => item)
	return (
		<div className={cl.root}>
			{COLUMN_ITEMS?.map(item => {
				if (item[0].TYPE === 'link_list') return <PopupList key={JSON.stringify(item)} items={item} />
				if (item[0].TYPE === 'brands') return <PopupBrands key={JSON.stringify(item)} items={item} />
				if (item[0].TYPE === 'banner') return <PopupBanners key={JSON.stringify(item)} items={item} />
				return <PopupList key={JSON.stringify(item)} items={item} />
			})}
		</div>
	)
})
